import React from "react";

const StaticPagesDataContextContext = React.createContext();

export const StaticPagesDataContextProvider = StaticPagesDataContextContext.Provider;
export const StaticPagesDataContextConsumer = StaticPagesDataContextContext.Consumer;

export default StaticPagesDataContextContext;
